const processors = {};

export const getProcessors = () => {
  return processors;
};

export const registerProcessor = (type, data) => {
  processors[type] = data;
};
